import { FC, useRef } from 'react';
import BeneficiaryInfo, { BeneficiaryFormRef, BeneficiaryInfoFormutil } from 'app/components/forms/BeneficiaryInfo';
import BackNextButtons from 'components/BackNextButtons';
import { usePowerNavigate } from 'components/PowerNavigate';
import values from 'stores/values';
import { CustomerInfoType } from 'types/customer';
import withProgressForm, { ProgressFormProps } from 'utils/withProgressForm';

const Beneficiary: FC<ProgressFormProps<BeneficiaryInfoFormutil>> = ({ onSubmit }) => {
    const { home_state_code, marital_status, tax_identification_number } = values.getParams<CustomerInfoType>();
    const beneficiaryFormRef = useRef<BeneficiaryFormRef>(null);
    const navigate = usePowerNavigate();
    const handleSubmit = (ev: React.FormEvent) => {
        onSubmit(async () => {
            const isPassed = await beneficiaryFormRef.current?.validateBeneficiary({
                homeStateCode: home_state_code,
                maritalStatus: marital_status
            });

            if (isPassed) {
                navigate('../revenue');
            }
        }, ev);
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <BeneficiaryInfo ref={beneficiaryFormRef} masterTaxNumber={tax_identification_number} />
            <BackNextButtons sticky />
        </form>
    );
};

export default withProgressForm({
    step: 4,
    id: 'beneficiary',
    ensure: ['account'],
    basePath: 'open'
})(Beneficiary);
